<div class="variant-skus">
  <ng-container *ngIf="false">
    <fieldset>
      <legend>Unit of Conversions</legend>
    </fieldset>
    <hr />
  </ng-container>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-default" (click)="addRfqConversionRules()">
      <i class="fas fa-plus"></i> Add New Unit of Conversion
    </button>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Base Unit of Measure</th>
        <th>Unit of Measure to Convert</th>
        <th>Conversion Factor</th>
        <th>Type</th>
        <th>Alternate Skus</th>
        <th width="70px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="rfqConversionRulesService.gettingRecords">
        <td colspan="13" class="text-center">
          <br />
          <h6 [translate]="'GENERAL.GETTING_RECORDS'">
            <i class="fas fa-spinner fa-spin"></i> Getting records...
          </h6>
          <br />
        </td>
      </tr>
      <tr *ngFor="let rfqConversionRule of rfqConversionRules.data; let i = index">
        <td>{{ rfqConversionRule.baseUnitOfMeasure?.name }}</td>
        <td>{{ rfqConversionRule.convertedUnitOfMeasure?.name }}</td>
        <td>{{ rfqConversionRule.conversionFactor | decimalPlaces }}</td>
        <td>{{ rfqConversionRule.type }}</td>
        <td>
          <ng-container
            *ngFor="let rfqAlternateSku of rfqConversionRule?.rfqAlternateSkus"
          >
            <span
              class="
                alternate-sku kt-badge kt-badge--primary kt-badge--outline kt-badge--pill ng-star-inserted
              "
            >
              {{ rfqAlternateSku.alternateSku }}
            </span>
          </ng-container>
        </td>
        <td>
          <div
            class="btn-group"
            *ngIf="rfqConversionRule.type === unitConversionRuleType.SKU"
          >
            <button
              type="button"
              (click)="editRfqConversionRules(rfqConversionRule)"
              class="btn btn-secondary"
            >
              Edit
            </button>
            <button
              type="button"
              (click)="deleteRfqConversionRules(rfqConversionRule)"
              class="btn btn-secondary"
            >
              Delete
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <mat-paginator
    [length]="rfqConversionRules.meta?.total"
    [pageSize]="rfqConversionRules.meta?.per_page"
    [pageSizeOptions]="pageSizeOptions"
    (page)="getRecords($event)"
  >
  </mat-paginator>
</div>
